import { action, props } from 'ts-action';
import { SkipHistory } from '../../undo/actions/undo.actions';
import { Signal } from '../types/signal';

export const loaded = action(
  '[Signal] loaded',
  props<{ signal: Signal } & SkipHistory>(),
);
